<!--
 * @Descripttion: 项目根组件
 * @Author: congz
 * @Date: 2020-06-04 11:22:40
 * @LastEditors: congz
 * @LastEditTime: 2020-09-01 14:34:14
--> 

<template>
  <div id="app" name="app">
    <el-container>
      <!-- 顶栏容器 -->

      <el-header v-show="$route.meta.showMenu!==false" style="background: #8B5A2B; border-bottom: 0; box-shadow: none;">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          active-text-color="#FFFFFF"
          background-color="transparent"
          text-color="#FFFFFF"
          router
          style="border-bottom:0;box-shadow:none; background: transparent;"
        >
          <div class="logo">
            <router-link to="/">
              <img src="./assets/imgs/clogo.png" alt />
            </router-link>
          </div>
          <el-menu-item index="/">HOME</el-menu-item>
          <el-menu-item index="/goods">SHOP</el-menu-item>
          <el-menu-item index="/about?id=1">OUR STORY</el-menu-item>
          <el-submenu index="faqs">
            <template slot="title">HELP</template>
            <el-menu-item index="/faqs?section=shopping">Delivery Info</el-menu-item>
            <el-menu-item index="/about?id=4">Returns &amp; Refunds</el-menu-item>
          </el-submenu>
          <el-menu-item index="/contact">CONTACT</el-menu-item>
          <div class="site-search">
            <el-input
              v-model="search"
              placeholder="Search product..."
              class="site-search-input dark-theme"
              @keyup.enter.native="searchClick"
            >
              <el-button slot="append" icon="el-icon-search" @click="searchClick"></el-button>
            </el-input>
          </div>
          <div class="menu-right">
            <div v-if="!this.$store.getters.getUser" class="menu-auth-wrap">
              <div class="menu-auth-trigger">
                <router-link to="/login" style="color: #fff;">Login</router-link>
                <span style="color: #fff;">/</span>
                <router-link to="/register" style="color: #fff;">Register</router-link>
              </div>
              <div class="menu-auth-panel">
                <div class="auth-tabs">
                  <span class="active">Sign in</span>
                  <router-link to="/register">Create an Account</router-link>
                </div>
                <div class="auth-field">Username or email address</div>
                <el-input size="mini" placeholder="Username or email address"></el-input>
                <div class="auth-field">Password</div>
                <el-input size="mini" type="password" placeholder="Password"></el-input>
                <el-button size="mini" type="primary" class="auth-submit">Log In</el-button>
                <div class="auth-footer">
                  <label><input type="checkbox" /> Remember me</label>
                  <router-link to="/login">Lost your password?</router-link>
                </div>
              </div>
            </div>
            <div v-else class="header-user-con">
              <div class="user-avator">
                <img :src="getUserAvatar" @error="handleAvatarError" />
              </div>
              <div class="user-name">
                <el-dropdown>
                  <span class="el-dropdown-link">
                    {{this.$store.getters.getUser.nickname}}
                    <i class="el-icon-caret-bottom"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <router-link to="/center">
                      <el-dropdown-item>Personal Center</el-dropdown-item>
                    </router-link>
                    <a @click="logout">
                      <el-dropdown-item>Logout</el-dropdown-item>
                    </a>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
            <router-link class="menu-text" to="/favorite">Wishlist</router-link>
            <router-link :class="getNum > 0 ? 'menu-cart menu-cart-full' : 'menu-cart'" to="/cart">
              Cart
              <span>{{getNum}}</span>
            </router-link>
          </div>
        </el-menu>
      </el-header>

      <!-- 顶栏容器END -->

      <!-- 移动端顶部栏 -->
      <div class="mobile-header" v-show="$route.meta.showMenu!==false">
        <div class="mobile-header-inner">
          <a href="javascript:void(0)" class="mobile-menu" @click.prevent="mobileMenuVisible = true">
            <i class="el-icon-menu"></i>
            <span>Menu</span>
          </a>
          <router-link class="mobile-logo" to="/">
            <img src="./assets/imgs/clogo.png" alt />
          </router-link>
          <router-link class="mobile-cart" to="/cart">
            <i class="el-icon-shopping-cart-full"></i>
            <span v-if="getNum>0" class="badge">{{getNum}}</span>
          </router-link>
        </div>
      </div>
      <!-- 移动端顶部栏END -->

      <!-- 移动端抽屉菜单 -->
      <el-drawer
        :visible.sync="mobileMenuVisible"
        direction="ltr"
        size="80%"
        custom-class="mobile-drawer"
        :with-header="false"
      >
        <div class="mobile-drawer-header">
          <span>Menu</span>
          <i class="el-icon-close" @click="mobileMenuVisible=false"></i>
        </div>
        <div class="mobile-drawer-body">
          <el-input
            v-model="mobileSearch"
            placeholder="Search for products"
            class="mobile-search"
            @keyup.enter.native="mobileSearchClick"
          >
            <el-button slot="append" icon="el-icon-search" @click="mobileSearchClick"></el-button>
          </el-input>
          <div class="drawer-switch">
            <button
              class="switch-btn"
              :class="{active: mobileMenuTab==='collection'}"
              @click="mobileMenuTab='collection'"
            >
              Collection
            </button>
            <button
              class="switch-btn"
              :class="{active: mobileMenuTab==='menu'}"
              @click="mobileMenuTab='menu'"
            >
              Menu
            </button>
          </div>
          <div class="drawer-content">
            <div v-if="mobileMenuTab==='collection'" class="mobile-drawer-section">
              <div class="section-title">Browse</div>
              <ul class="link-list">
                <li v-for="item in shopCategories" :key="item.category_id">
                  <router-link :to="`/goods?categoryID=${item.category_id}`" @click.native="mobileMenuVisible=false">
                    {{item.category_name}}
                  </router-link>
                </li>
              </ul>
            </div>
            <div v-else class="mobile-drawer-section">
              <div class="section-title">Navigate</div>
              <ul class="link-list">
                <li><router-link to="/" @click.native="mobileMenuVisible=false">Home</router-link></li>
                <li><router-link to="/about?id=1" @click.native="mobileMenuVisible=false">Our Story</router-link></li>
                <li><router-link to="/order" @click.native="mobileMenuVisible=false">My Orders</router-link></li>
                <li><router-link to="/favorite" @click.native="mobileMenuVisible=false">Favorites</router-link></li>
                <li><router-link to="/goods" @click.native="mobileMenuVisible=false">All Products</router-link></li>
              </ul>
            </div>
          </div>
        </div>
      </el-drawer>
      <!-- 移动端抽屉菜单END -->

      <!-- 主要区域容器 -->
      <el-main>
        <keep-alive>
          <router-view :key="key"></router-view>
        </keep-alive>
      </el-main>
      <!-- 主要区域容器END -->

      <!-- 移动端底部TabBar -->
      <div class="mobile-tabbar" v-show="$route.meta.showMenu!==false">
        <router-link to="/goods" class="tab">
          <i class="el-icon-s-goods"></i>
          <span>Browse</span>
        </router-link>
        <router-link to="/favorite" class="tab">
          <i class="el-icon-star-off"></i>
          <span>Saved</span>
        </router-link>
        <router-link to="/cart" class="tab">
          <i class="el-icon-shopping-cart-1"></i>
          <span>Bag</span>
          <em v-if="getNum>0" class="dot">{{getNum}}</em>
        </router-link>
        <router-link to="/center" class="tab">
          <i class="el-icon-user"></i>
          <span>Profile</span>
        </router-link>
      </div>
      <!-- 移动端底部TabBar END -->

      <!-- 底栏容器 -->
      <el-footer>
        <div class="footer">
          <div class="footer-subscribe-section">
             <div class="subscribe-title">Stay in the Loop</div>
             <div class="subscribe-action">
                <button class="subscribe-btn-arrow"><i class="el-icon-right"></i></button>
             </div>
          </div>
          <div class="footer-content">
            <div class="footer-links-group">
              <div class="footer-col">
                <h4>Quick Links</h4>
                <router-link to="/about?id=6">Terms of Service</router-link>
                <router-link to="/about?id=2">Privacy Policy</router-link>
              </div>
              <div class="footer-col">
                <h4>Support</h4>
                <router-link to="/about?id=1">About Us</router-link>
                <router-link to="/contact">Contact Us</router-link>
                <router-link to="/about?id=4">Returns Policy</router-link>
                <router-link to="/faqs">FAQs</router-link>
              </div>
            </div>

             <div class="footer-right-promo">
               <h4>Get in Touch</h4>
               <p>ALMEXIS IT & SUPPORT PRIVATE LIMITED</p>
               <div class="footer-contact-info">
                  <p><i class="el-icon-location"></i> Floor No.: B-11, A-82 , A One Ambroideries, Sector 4 Noida, Gautambuddha Nagar, Uttar Pradesh- 201301</p>
                  <p><i class="el-icon-phone"></i> +91 9802238261</p>
                  <p><i class="el-icon-message"></i> almexisit15@gmail.com</p>
               </div>
            </div>
          </div>
          <div class="footer-copyright">
            Copyright © 2026, ALMEXIS IT & SUPPORT PRIVATE LIMITED. All Rights Reserved.
          </div>
        </div>
      </el-footer>
      <!-- 底栏容器END -->
    </el-container>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { mapGetters } from 'vuex'
import * as cartsAPI from '@/api/carts'
import * as userAPI from '@/api/users'
import * as categoryAPI from '@/api/categories'

export default {
  beforeUpdate() {
    this.activeIndex = this.$route.path
  },
  data() {
    return {
      activeIndex: '', // 头部导航栏选中的标签
      search: '', // 搜索条件
      shopCategories: [],
      mobileMenuVisible: false,
      mobileSearch: '',
      mobileMenuTab: 'collection'
    }
  },
  beforeCreate() {
    document.querySelector('body').setAttribute('style', 'background:#F5F7FA')
  },
  created() {
    // 获取浏览器localStorage，判断用户是否已经登录
    userAPI.checkToken(localStorage.getItem('token')).then(res => {
      // 如果已经登录，设置vuex登录状态
      if (res.status == 200) {
        this.setUser(JSON.parse(localStorage.getItem('user')))
      } else {
        localStorage.removeItem('user')
        localStorage.removeItem('token')
      }
    })
    categoryAPI
      .listCategories()
      .then(res => {
        if (res.status === 200) {
          this.shopCategories = res.data
        } else {
          this.notifyError('Failed to obtain classification', res.msg)
        }
      })
      .catch(err => {
        this.notifyError('Failed to obtain classification', err)
      })
  },
  computed: {
    ...mapGetters(['getUser', 'getNum']),
    key() {
      return this.$route.path
    },
    getUserAvatar() {
      const user = this.$store.getters.getUser
      if (user && user.avatar && user.avatar.trim() !== '') {
        return user.avatar
      }
      // 使用在线服务生成默认头像（基于昵称首字母）
      const name = encodeURIComponent((user && user.nickname) || 'U')
      return `https://ui-avatars.com/api/?name=${name}&background=4338CA&color=fff&size=80&font-size=0.4`
    }
  },
  watch: {
    // 获取vuex的登录状态
    getUser: function(val) {
      if (val === '') {
        // 用户没有登录
        this.setShoppingCart([])
      } else {
        // 用户已经登录,获取该用户的购物车信息
        cartsAPI
          .showCarts(val.id)
          .then(res => {
            if (res.status === 200) {
              if (res.data === null) {
                this.setShoppingCart([])
              } else {
                this.setShoppingCart(res.data)
              }
            } else if (res.status === 20001) {
              //token过期，需要重新登录
              this.loginExpired(res.msg)
            } else {
              this.$notify.error({
                title: '购物车获取失败',
                message: res.msg
              })
            }
          })
          .catch(err => {
            return Promise.reject(err)
          })
      }
    }
  },
  methods: {
    ...mapActions(['setUser', 'setShoppingCart']),
    login() {
      this.$router.push({
        name: 'Login'
      })
    },
    // 退出登录
    logout() {
      // 清空本地登录信息
      localStorage.removeItem('user')
      localStorage.removeItem('token')
      // 清空vuex登录信息
      this.setUser('')
      this.$router.push({
        name: 'Home'
      })
      this.notifySucceed('success')
    },
    //重定向
    register() {
      this.$router.push({
        name: 'Register'
      })
    },
    // 点击搜索按钮
    searchClick() {
      if (this.search != '') {
        // 跳转到全部商品页面,并传递搜索条件
        this.$router.push({ path: '/goods', query: { search: this.search } })
        this.search = ''
      }
    },
    mobileSearchClick() {
      if (this.mobileSearch) {
        this.$router.push({ path: '/goods', query: { search: this.mobileSearch } })
        this.mobileSearch = ''
        this.mobileMenuVisible = false
      }
    },
    // 处理头像加载失败
    handleAvatarError(e) {
      e.target.src = 'https://ui-avatars.com/api/?name=U&background=4338CA&color=fff&size=80&font-size=0.4'
    }
  }
}
</script>

<style>
/* 全局CSS */
* {
  padding: 0;
  margin: 0;
  border: 0;
  list-style: none;
}

.header-user-con {
  display: flex;
  height: 44px;
  align-items: center;
}
.user-name {
  margin-left: 10px;
}
.user-avator img {
  display: block;
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.el-dropdown-link {
  color: #fff;
  cursor: pointer;
}

.el-dropdown-menu__item {
  text-align: center;
}
.el-dropdown-item:hover {
  color: #141E30;
}

#app .el-header {
  padding: 0;
}
#app .el-main {
  min-height: 300px;
  padding: 0;
  overflow: visible;
}
#app .el-footer {
  padding: 0;
}
a,
a:hover {
  text-decoration: none;
}
/* 全局CSS END */

/* 默认隐藏移动端专用按钮（桌面端不显示） */
.mobile-header,
.mobile-tabbar {
  display: none;
}

/* 顶部导航栏CSS */
/* 顶栏容器CSS */
.el-header {
  margin-bottom: 0;
  background: #8B5A2B;
  border-bottom: 0;
}
.el-header .el-menu {
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  padding: 0 24px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-color: transparent;
  flex-wrap: nowrap;
  border-bottom: 0;
}
.el-menu--horizontal>.el-menu-item.is-active {
  color: #1C2B3A;
}
.el-menu--horizontal {
  border-bottom: 0;
}
.el-menu--horizontal > .el-menu-item,
.el-menu--horizontal > .el-submenu .el-submenu__title {
  border-bottom: 0;
}

.el-header .logo {
  height: 60px;
  width: 100px;
  float: left;
  margin-right: 40px;
  flex-shrink: 0;
}
.site-search {
  margin-left: 16px;
  margin-right: auto;
  width: 520px;
  max-width: 42vw;
}
.site-search-input .el-input__inner {
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: #ffffff;
  border-radius: 20px 0 0 20px;
}
.site-search-input .el-input-group__append {
  background-color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-left: 0;
  border-radius: 0 20px 20px 0;
  padding: 0;
}
.site-search-input .el-input-group__append .el-button {
  background: transparent;
  border: none;
  color: #1C2B3A;
  margin: 0;
  padding: 12px 20px;
}
.site-search-input .el-input-group__append .el-button:hover {
  color: #4338CA;
  background-color: transparent;
}
.el-menu--horizontal > .el-menu-item,
.el-menu--horizontal > .el-submenu {
  flex-shrink: 0;
}
.el-header .logo img {
  height: 52px;
  margin-top: 4px;
  border-radius: 8px;
}
.menu-right {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 16px;
  color: #2D2D2D;
  flex-shrink: 0;
}
.menu-auth-wrap {
  position: relative;
}
.menu-auth-trigger {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: #FFFFFF;
  white-space: nowrap;
}
.menu-auth-trigger a {
  color: #FFFFFF;
}
.menu-auth-panel {
  position: absolute;
  right: 0;
  top: 34px;
  width: 270px;
  background: #ffffff;
  color: #2f2238;
  border-radius: 6px;
  padding: 14px;
  box-shadow: 0 16px 30px rgba(0, 0, 0, 0.18);
  display: none;
  z-index: 10;
}
.menu-auth-wrap:hover .menu-auth-panel {
  display: block;
}
.auth-tabs {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  margin-bottom: 10px;
}
.auth-tabs .active {
  font-weight: 600;
  color: #2f2238;
}
.auth-tabs a {
  color: #6d637b;
}
.auth-field {
  font-size: 11px;
  color: #6d637b;
  margin: 8px 0 4px;
}
.auth-submit {
  margin-top: 10px;
  width: 100%;
  background: #8B5A2B;
  border-color: #141E30;
}
.auth-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 11px;
  color: #6d637b;
  margin-top: 10px;
}
.auth-footer a {
  color: #6d637b;
}
.auth-footer input {
  margin-right: 6px;
}
.menu-text {
  color: #FFFFFF;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}
.menu-cart {
  position: relative;
  padding-right: 10px;
}
.menu-cart span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  font-size: 10px;
  background: #141E30;
  color: #ffffff;
  border-radius: 50%;
  margin-left: 6px;
}
.menu-cart.menu-cart-full span {
  box-shadow: 0 0 0 2px #1C2B3A;
}

@media (max-width: 1100px) {
  .site-search { display: none; }
}
.menu-cart {
  color: #FFFFFF;
  padding: 6px 12px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 14px;
  font-size: 12px;
  letter-spacing: 0.2px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.menu-cart-full {
  background: #4A6FA5;
  color: #2D2D2D;
}
.el-menu--horizontal > .el-menu-item {
  color: #FFFFFF;
  font-weight: 600;
  letter-spacing: 0.4px;
}
.el-menu--horizontal > .el-menu-item.is-active {
  color: #FDF8F5;
}
.el-menu--horizontal > .el-menu-item:not(.is-disabled):hover {
  color: #FDF8F5;
}
.el-menu--horizontal > .el-submenu .el-submenu__title {
  color: #FFFFFF;
  font-weight: 600;
  letter-spacing: 0.4px;
}
.el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  color: #FDF8F5;
}
.el-menu--horizontal > .el-submenu:not(.is-disabled):hover .el-submenu__title {
  color: #FDF8F5;
}

/* 顶栏容器CSS END */

/* 底栏容器CSS */
.footer {
  width: 100%;
  background: #8B5A2B;
  color: #ffffff;
  padding: 60px 0;
}
.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 40px;
  padding: 0 24px;
}
.footer-left {
  flex: 1;
  max-width: 300px;
}
.footer-logo {
  font-size: 24px;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
}
.footer-slogan {
  font-size: 14px;
  line-height: 1.6;
  color: #94A3B8;
}
.footer-links-group {
  flex: 2;
  display: flex;
  justify-content: space-around;
  gap: 20px;
}
.footer-col h4 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #ffffff;
}
.footer-col a {
  display: block;
  color: #94A3B8;
  font-size: 14px;
  margin-bottom: 12px;
  transition: color 0.3s;
}
.footer-col a:hover {
  color: #ffffff;
}
.footer-right {
  flex: 1;
  max-width: 300px;
}
.footer-right h4 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #ffffff;
}
.footer-email-input {
  display: flex;
  border-bottom: 1px solid #334155;
  padding-bottom: 10px;
}
.footer-email-input input {
  background: transparent;
  border: none;
  color: #ffffff;
  flex: 1;
  outline: none;
  font-size: 14px;
}
.footer-email-input button {
  background: transparent;
  border: none;
  color: #ffffff;
  cursor: pointer;
  font-size: 18px;
}
.footer-email-input button:hover {
  color: #94A3B8;
}
.footer-copyright {
    text-align: center;
    font-size: 13px;
    color: #94A3B8;
    margin-top: 40px;
    padding-top: 20px;
    border-top: 1px solid #334155;
  }
/* 底栏容器CSS END */

/* 移动端适配 */
@media (max-width: 900px) {
  .el-header {
    display: none;
  }
  #app .el-main {
    padding-top: 56px;
    padding-bottom: 64px;
  }
  .mobile-header {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100vw;
    height: 56px;
    background: #8B5A2B;
    z-index: 1000;
    border-bottom: 0;
  }
  .mobile-header-inner {
    width: 100%;
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 12px;
    color: #ffffff;
  }
  .mobile-header a {
    color: #ffffff;
    display: flex;
    align-items: center;
    gap: 6px;
  }
  .mobile-logo img {
    height: 34px;
    border-radius: 10px;
  }
  .mobile-cart {
    position: relative;
    margin-right: 28px;
  }
  .mobile-cart .badge {
    position: absolute;
    top: -4px;
    right: -8px;
    background: #4A6FA5;
    color: #2D2D2D;
    font-size: 10px;
    line-height: 1;
    padding: 3px 5px;
    border-radius: 10px;
  }
  .mobile-tabbar {
    position: fixed;
    left: 0;
    right: 0;
    width: 100vw;
    bottom: 0;
    height: 64px;
    background: #ffffff;
    border-top: 1px solid #E8D4D4;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    z-index: 20;
  }
  .mobile-tabbar .tab {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #999999;
    position: relative;
    font-size: 11px;
  }
  .mobile-tabbar .tab.router-link-active {
    color: #1C2B3A;
  }
  .mobile-tabbar .tab .dot {
    position: absolute;
    right: 18px;
    top: 10px;
    font-size: 10px;
    color: #fff;
    background: #8B5A2B;
    border-radius: 10px;
    padding: 2px 5px;
    line-height: 1;
  }
  .footer {
    border-radius: 8px 8px 0 0;
    width: 100vw;
    padding-bottom: calc(16px + 64px);
  }
  .footer-content {
    flex-direction: column;
    gap: 30px;
  }
  .footer-left, .footer-links-group, .footer-right {
    max-width: 100%;
    flex: auto;
  }
  .footer-links-group {
    justify-content: space-between;
  }
}

/* 抽屉菜单样式（小屏专用） */
@media (max-width: 900px) {
  .mobile-drawer {
    background: #1C2B3A !important;
  }
  .mobile-drawer .el-drawer__body {
    padding: 0;
    background: #8B5A2B;
    color: #ffffff;
  }
  .mobile-drawer-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 16px;
    border-bottom: 1px solid #334155;
    font-weight: 600;
    color: #FFFFFF;
    background: #8B5A2B;
  }
  .mobile-drawer-header i {
    font-size: 18px;
    cursor: pointer;
    color: #FFFFFF;
  }
  .mobile-drawer-body {
    padding: 12px 14px 24px;
    background: #8B5A2B;
  }
  .mobile-search {
    margin-bottom: 16px;
  }
  .mobile-search >>> .el-input__inner {
    background: #334155;
    border: 1px solid #475569;
    color: #ffffff;
  }
  .mobile-search >>> .el-input-group__append .el-button {
    background: #4338CA;
    border: 1px solid #3730A3;
    color: #FFFFFF;
  }
  .drawer-switch {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    margin-bottom: 8px;
  }
  .drawer-switch .switch-btn {
    height: 40px;
    border-radius: 6px;
    background: #334155;
    color: #ffffff;
    font-weight: 600;
    border: 1px solid #475569;
  }
  .drawer-switch .switch-btn.active {
    background: #4338CA;
    color: #ffffff;
    box-shadow: none;
    border-color: #3730A3;
  }
  .drawer-content {
    height: calc(100vh - 160px);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
  .mobile-drawer-section .section-title,
  .drawer-col .section-title {
    font-size: 12px;
    letter-spacing: 0.4px;
    color: #94A3B8;
    margin-bottom: 8px;
    text-transform: uppercase;
  }
  .mobile-drawer-section .link-list li a,
  .drawer-col .link-list li a {
    display: block;
    padding: 12px 0;
    border-bottom: 1px solid #334155;
    color: #ffffff;
  }
  /* 两栏布局 */
  .drawer-columns {
    display: none;
  }
  .drawer-col {
    padding-right: 0;
  }
  .drawer-left {
    border-right: 0;
  }
}
</style>
